/* Shared money and modal behavior for the Techniques sections. */
window.Tc = window.Tc || {};
// Adds the currency code when it differs from the store's own (window.TcMoneyCode, set in tc-head); plain skips it, for struck-through prices
Tc.money = (cents, plain) => {
  const code = !plain && window.TcMoneyCode ? ' ' + window.TcMoneyCode : '';
  return Tc.moneyAmount(cents) + code;
};
Tc.moneyAmount = (cents) => {
  const format = window.theme_variables?.settings?.money_format || '${{amount}}';
  const formats = {
    amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
    amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','],
    amount_with_period_and_space_separator: [2, ' ', '.']
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, token) => {
    const [precision, thousands, decimal] = formats[token] || formats.amount;
    const [whole, fraction] = (Number(cents) / 100).toFixed(precision).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
  });
};

Tc.modal = (dialog, trigger, initial, allow = []) => {
  const changed = [];
  let branch = dialog;
  while (branch.parentElement) {
    [...branch.parentElement.children].forEach((el) => {
      if (el === branch || el.inert || allow.some((item) => el === item || el.contains(item))) return;
      el.inert = true; changed.push(el);
    });
    branch = branch.parentElement;
    if (branch === document.body) break;
  }
  const overflow = document.documentElement.style.overflow;
  document.documentElement.style.overflow = 'hidden';
  const controls = () => [...dialog.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]')]
    .filter((el) => {
      if (el.disabled || el.tabIndex < 0 || el.closest('[hidden], [inert]') || !el.getClientRects().length || getComputedStyle(el).visibility === 'hidden') return false;
      // Some engines return rectangles for descendants of closed details.
      for (let parent = el.parentElement; parent && parent !== dialog; parent = parent.parentElement) {
        if (parent.tagName === 'DETAILS' && !parent.open && !(el.tagName === 'SUMMARY' && el.parentElement === parent)) return false;
      }
      return true;
    });
  const focus = () => (controls()[0] || dialog).focus({ preventScroll: true });
  const onKey = (e) => {
    if (e.key !== 'Tab') return;
    const items = controls();
    e.preventDefault();
    if (!items.length) return;
    // WebKit may skip links with its default keyboard preference. Keep the
    // complete dialog sequence reachable, including its boundary controls.
    const index = items.indexOf(document.activeElement);
    const next = index < 0 ? (e.shiftKey ? items.length - 1 : 0)
      : (index + (e.shiftKey ? -1 : 1) + items.length) % items.length;
    items[next].focus();
  };
  const onFocus = (e) => { if (!dialog.contains(e.target)) focus(); };
  document.addEventListener('keydown', onKey, true);
  document.addEventListener('focusin', onFocus);
  (initial || controls()[0] || dialog).focus({ preventScroll: true });
  return (restore = true) => {
    document.removeEventListener('keydown', onKey, true);
    document.removeEventListener('focusin', onFocus);
    changed.forEach((el) => { el.inert = false; });
    document.documentElement.style.overflow = overflow;
    if (restore && trigger?.isConnected) trigger.focus({ preventScroll: true });
  };
};
